import PageHero from "@/components/layout/PageHero";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import { Award, Heart, Shield, Users } from "lucide-react";

const STATS = [
  { label: "Trusted travellers", value: "1M+" },
  { label: "Partner brands", value: "120" },
  { label: "Countries covered", value: "180" },
  { label: "Years of curation", value: "8" },
];

const VALUES = [
  { icon: Heart, title: "Traveller-first", desc: "We surface the best deals and most honest reviews — even when it isn't profitable for us." },
  { icon: Shield, title: "Transparent", desc: "Affiliate disclosures are upfront. You always know how we earn — never inflated prices." },
  { icon: Award, title: "Curated quality", desc: "Every partner, hotel and deal is vetted by our editorial team before going live." },
  { icon: Users, title: "Made in India", desc: "Built in Bengaluru for Indian and global travellers. Designed for visa rules, currency and culture." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero
        kicker="About MyTripPoint"
        title="Travel made simple, transparent and human"
        subtitle="We started MyTripPoint to fix a frustrating travel-planning experience. Today we help over a million Indian and international travellers compare and book with confidence."
      />
      <div className="container-page py-10">
        <Breadcrumbs items={[{ label: "About" }]} />
        <div className="grid md:grid-cols-4 gap-5 mt-2">
          {STATS.map((s) => (
            <div key={s.label} className="bg-white border border-slate-200 rounded-2xl p-5 text-center">
              <div className="font-montserrat font-extrabold text-3xl text-brand">{s.value}</div>
              <div className="text-xs text-slate-500 mt-1 uppercase tracking-wider">{s.label}</div>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-12 mt-14 items-center">
          <div>
            <div className="text-xs font-bold uppercase tracking-widest text-accent mb-3">Our Mission</div>
            <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-slate-900 leading-tight">
              Helping travellers save more and stress less.
            </h2>
            <p className="mt-4 text-slate-700 leading-relaxed">
              We believe travel should be exciting from the moment you start planning. That's why MyTripPoint compares deals from Booking.com, Agoda, MakeMyTrip and Skyscanner in one place, layers in independent visa & destination guides, and surfaces the deals our editorial team actually recommends.
            </p>
            <p className="mt-3 text-slate-700 leading-relaxed">
              We are an affiliate platform — meaning when you book through our partner links we earn a small commission. You never pay extra for it. See our <a href="/affiliate-disclosure" className="text-brand underline">Affiliate Disclosure</a>.
            </p>
          </div>
          <img src="https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?auto=format&fit=crop&w=1200&q=80" alt="team" className="w-full h-80 object-cover rounded-2xl border border-slate-200" loading="lazy" />
        </div>

        <div className="mt-16">
          <h2 className="font-montserrat font-bold text-2xl md:text-3xl text-slate-900 mb-6">What we stand for</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {VALUES.map((v) => (
              <div key={v.title} className="bg-white border border-slate-200 rounded-2xl p-5">
                <div className="w-11 h-11 inline-flex items-center justify-center rounded-xl bg-brand-50 text-brand mb-3">
                  <v.icon size={20} />
                </div>
                <div className="font-montserrat font-bold text-slate-900">{v.title}</div>
                <p className="text-sm text-slate-600 mt-1">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
